var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',_vm._g(_vm._b({ref:"real_form",staticClass:"rails_form"},'b-form',_vm.$attrs,false),_vm.$listeners),[_c('input',{attrs:{"type":"hidden","name":"authenticity_token"},domProps:{"value":_vm.csrf_token}}),_vm._v(" "),_c('input',{attrs:{"name":"utf8","type":"hidden","value":"&#x2713;"}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }